import { UI, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';
interface OfferSummaryHeaderProps {
  totalValue: string;
  orderHash: string;
}

export const OfferSummaryHeader: React.FC<OfferSummaryHeaderProps> = ({
  totalValue,
  orderHash,
}) => {
  return (
    <VStack space={Spacing['inline.sm']}>
      <UI.Heading testId="offer-summary-header" size="h3" color="brand.primary.principal">
        Ordem {orderHash}
      </UI.Heading>

      <VStack space={Spacing['stack.quarck']}>
        <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
          Valor da operação
        </UI.Text>
        <UI.Heading
          testId="offer-summary-header-total"
          size="h4"
          color="brand.primary.principal"
          fontSize={Typography['fontsize.xl']}>
          {totalValue}
        </UI.Heading>
      </VStack>
    </VStack>
  );
};
